import type { ReactNode } from "react";

type SectionProps = {
  children: ReactNode;
  /**
   * `plain` is the white default. `tinted` uses the same pale blue already used
   * by the teacher profile header, so stacked sections alternate instead of
   * running together as one flat white page.
   */
  tone?: "plain" | "tinted";
  className?: string;
};

/**
 * Wrapper for a top-level public-site section.
 *
 * The public pages previously stacked their sections directly, each bringing
 * its own ad-hoc padding and all on the same white background, so the page read
 * as one undifferentiated column. This gives every section the same horizontal
 * container and vertical rhythm, and lets consecutive sections alternate tone
 * so the eye can tell where one ends and the next begins.
 */
export default function Section({
  children,
  tone = "plain",
  className = "",
}: SectionProps) {
  return (
    <section
      className={`${tone === "tinted" ? "bg-[#F7FBFE]" : "bg-white"} ${className}`}
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 py-14 lg:py-20">
        {children}
      </div>
    </section>
  );
}
